module.exports = __webpack_public_path__ + "src/assets/textures/leaves/board/wood_board.png";